export default {
  "brand.name": "USFansSheet",
  "nav.home": "Strona główna",
  "nav.categories": "Kategorie",
  "nav.article": "Poradniki",
  "nav.faq": "FAQ",
  "nav.shoppingGuide": "Przewodnik zakupowy",
  "nav.guides": "Poradniki",
  "buttons.buyNow": "Kup teraz",
  "buttons.usfansSpreadsheet": "USFans Spreadsheet",
  "buttons.viewAll": "Zobacz wszystkie kategorie",
  "buttons.go": "Przejdź",
  "categories.shoes": "Buty",
  "categories.hoodies": "Bluzy / Swetry",
  "categories.tshirts": "Koszulki",
  "categories.jackets": "Kurtki",
  "categories.pants": "Spodnie / Szorty",
  "categories.headwear": "Nakrycia głowy",
  "categories.sets": "Zestawy",
  "categories.underwear": "Bielizna / Bokserki",
  "categories.jersey": "Koszulka sportowa",
  "categories.accessories": "Akcesoria",
  "categories.bags": "Torby",
  "categories.belts": "Paski",
  "categories.perfumes": "Perfumy",
  "categories.other": "Inne rzeczy",
  "footer.disclaimer": "USFansSheet to niezależne źródło informacji. Informacje mogą się zmieniać z czasem. Zawsze samodzielnie weryfikuj aktualne informacje o produktach, sprzedawcach, wysyłce, płatnościach i promocjach przed podjęciem decyzji.",
  "footer.rights": "Wszelkie prawa zastrzeżone.",
  "footer.explore": "Odkrywaj",
  "footer.categories": "Kategorie",
  "footer.resources": "Zasoby",
  "footer.backHome": "Wróć do strony głównej",
  "pillar.title": "Przewodniki",
  "pillar.subtitle": "Poznaj nasze szczegółowe przewodniki po badaniach USFans, QC, wysyłce, bezpieczeństwie i innych tematach.",
  "pillar.readMore": "Przeczytaj poradnik",
  "published": "Opublikowano",
  "updated": "Zaktualizowano",
  "readingTime": "min czytania",
  "backHome": "Wróć do strony głównej",
  "breadcrumbHome": "Strona główna",
  "breadcrumbCurrent": "Poradnik",
  "notFound.title": "Poradnik nie znaleziony",
  "notFound.back": "Wróć do strony głównej",
  "tag.beginner": "Poradnik dla początkujących",
  "tag.research": "Przewodnik badawczy",
  "tag.qc": "Przewodnik QC",
  "tag.shipping": "Przewodnik wysyłki",
  "tag.warehouse": "Przewodnik magazynu",
  "tag.safety": "Przewodnik bezpieczeństwa",
  "tag.categories": "Przewodnik kategorii",
  "tag.compare": "Przewodnik porównania",
  "tag.coupon": "Przewodnik kuponów",
  "tag.seller": "Przewodnik sprzedawców",
};